import { injectService } from '@/inversify.config';
import ListOperationServLock from '@/presentation/pages/detail/basic/interface_lock/ListOperationServLock';
import { CopyMoveViewDataServiceSymbol } from '@/presentation/pages/detail/basic/service/CopyMoveViewDataService';
import _ from 'lodash';
export default class ClinicalListOperationService extends ListOperationServLock {
    async onUnselectAll() {
        throw new TypeError('onUnselect is not implemented');
    }
    get selectedCount() {
        throw new TypeError('Clinical selectedCount is not implemented');
    }
    async startTargetFolderSelection(mode) {
        const copyMoveViewDataService = injectService(CopyMoveViewDataServiceSymbol);
        return copyMoveViewDataService.open({ mode, selectedCount: this.selectedCount });
    }
    async onCopy(requestPayloadOverrides = {}) {
        if (_.isEmpty(requestPayloadOverrides)) {
            throw new TypeError('onCopy need requestPayloadOverrides');
        }
        const target = await this.startTargetFolderSelection('copy');
        await this.postListChange('copy', target, requestPayloadOverrides);
    }
    async onMove(requestPayloadOverrides = {}) {
        if (_.isEmpty(requestPayloadOverrides)) {
            throw new TypeError('onMove need requestPayloadOverrides');
        }
        const target = await this.startTargetFolderSelection('move');
        await this.postListChange('move', target, requestPayloadOverrides);
    }
    async onDelete() {
        throw new TypeError('onDelete is not implemented');
    }
    onSetReadStatus() {
        throw new TypeError('onDelete is not implemented');
    }
    async openEditCustomFieldDialog() {
        throw new TypeError('openEditCustomFieldDialog is not implemented');
    }
}
